import { useEffect } from 'react';
import ReactDOM from 'react-dom';
import I18n from 'I18n';
import { GENERIC_CERT_DIMENSIONS } from '../../../constants/CourseConstants';
import { useAchievementCertificateUrl, useAchievementTrackId, usePublicAchievement, useTrackPublicData } from '../achievementQueries';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const hrefBeforeSearch = ({
  origin,
  pathname
}) => `${origin}${pathname}`;
const removeAll = (container, selector) => {
  const els = container.querySelectorAll(selector);
  for (const el of els) {
    if (!el.parentNode) return;
    el.parentNode.removeChild(el);
  }
};
// See https://github.com/prerender/prerender#httpheaders
const DynamicHeadTags = ({
  head,
  publicId,
  wasFound
}) => {
  useEffect(() => {
    removeAll(head, '.override-with-translation');
  }, [head]);
  const {
    publicAchievement,
    publicAchievementLoading
  } = usePublicAchievement(publicId);
  const image = useAchievementCertificateUrl(publicId);
  const trackId = useAchievementTrackId(publicId);
  const {
    track: trackPublicData,
    trackLoading
  } = useTrackPublicData(trackId);
  const courseName = (trackPublicData === null || trackPublicData === void 0 ? void 0 : trackPublicData.name) || '';
  useEffect(() => {
    if (!publicAchievementLoading && (!trackId || !trackLoading)) {
      window.prerenderReady = true;
    }
  }, [publicAchievementLoading, trackId, trackLoading]);
  return wasFound || !!publicAchievement ? /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("title", {
      children: I18n.text('learningCenter.certification.htmlTitle', {
        courseName
      })
    }), /*#__PURE__*/_jsx("meta", {
      content: I18n.text('learningCenter.certification.htmlTitle', {
        courseName
      }),
      property: "og:title"
    }), /*#__PURE__*/_jsx("meta", {
      content: I18n.text('learningCenter.certification.ogDescription', {
        courseName
      }),
      property: "og:description"
    }), /*#__PURE__*/_jsx("meta", {
      content: hrefBeforeSearch(window.location),
      property: "og:url"
    }), /*#__PURE__*/_jsx("meta", {
      content: image || undefined,
      property: "og:image"
    }), /*#__PURE__*/_jsx("meta", {
      content: GENERIC_CERT_DIMENSIONS.WIDTH.toString(),
      property: "og:image:width"
    }), /*#__PURE__*/_jsx("meta", {
      content: GENERIC_CERT_DIMENSIONS.HEIGHT.toString(),
      property: "og:image:height"
    }), /*#__PURE__*/_jsx("meta", {
      content: "website",
      property: "og:type"
    }), /*#__PURE__*/_jsx("meta", {
      content: "summary",
      name: "twitter:card"
    })]
  }) : /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("title", {
      children: I18n.text('learningCenter.certification.achievementNotFoundTitle')
    }), /*#__PURE__*/_jsx("meta", {
      content: "404",
      name: "prerender-status-code"
    })]
  });
};
const PrerenderGlobals = ({
  head = document.head,
  publicId,
  wasFound
}) => /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/_jsx(DynamicHeadTags, {
  head: head,
  publicId: publicId,
  wasFound: wasFound
}), head);
export default PrerenderGlobals;